import moment from "moment";
import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import axios from "axios";
import FileDownload from "js-file-download";
import { parse } from "json2csv";
import constants from "../../utils/constants";
import { PaymentComplementReportFilters } from "../../types/PaymentComplementReport";
import { openPaymentComplementXml } from "./billing";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../utils/notifications";

// Flujo estándar vía BFF (como facturas / billing), no directo a ms-finanzas.
const PAYMENT_COMPLEMENTS_BASE_URL = "/api/billing/payment-complements";

/**
 * Consulta el reporte de complementos de pago a través del BFF.
 */
export const getPaymentComplementReport = (
  filters: PaymentComplementReportFilters = {}
): IAction => {
  return {
    type: actionTypes.GET_PAYMENT_COMPLEMENT_REPORT,
    payload: {
      promise: axios.get(
        `${constants.BASE_URL}${PAYMENT_COMPLEMENTS_BASE_URL}/reporte`,
        {
          withCredentials: true,
          params: {
            startDate: filters.fechaInicio || undefined,
            endDate: filters.fechaFin || undefined,
            referenceFolio: filters.referenceFolio || undefined,
            receiverRfc: filters.receiverRfc || undefined
          }
        }
      )
    }
  };
};

/**
 * Abre el XML del complemento en una nueva pestaña,
 * mismo flujo que validación de complementos / facturas (BFF billing).
 */
export const openPaymentComplementReportXml = (uuid: string) => {
  if (!uuid) {
    errorNotification("El complemento no tiene UUID");
    return;
  }
  openPaymentComplementXml(uuid);
};

const CSV_FIELDS = [
  "Fecha Emision",
  "Fecha Certificacion Sat",
  "Folio de la factura",
  "Folio del complemento de pago",
  "UUID",
  "RFC Emisor",
  "RFC Receptor",
  "Nombre Receptor",
  "Uso CFDI",
  "Fecha Pago",
  "Forma De Pago",
  "Moneda",
  "Monto del pago",
  "Monto total de la factura",
  "UUID Relacionado"
];

/**
 * Genera y descarga un CSV solo con las filas ya preparadas desde la tabla
 * de resultados de búsqueda. El nombre del archivo incluye fecha y hora.
 */
export const downloadPaymentComplementReportCsv = (rows: object[]) => {
  if (!rows || !rows.length) {
    errorNotification("No hay resultados para descargar");
    return;
  }

  try {
    infoNotification("Descargando reporte");
    const csv = parse(rows, { fields: CSV_FIELDS, quotes: '"' });
    const fileName = `ReporteComplementosPago_${moment().format(
      "YYYYMMDD_HHmm"
    )}.csv`;
    FileDownload(csv, fileName);
    successNotification("Reporte descargado");
  } catch (error) {
    errorNotification("No se pudo generar el archivo CSV");
  }
};
